import Vue from "vue";
import { markPuzzleRating } from "js/crossword/ratingStore";
import { getFeedSlug } from "js/crossword/getYearsInfo";
import { getGameSlug } from "js/crossword/sdk/getGameSlug";
import { getPublisherId } from "js/crossword/sdk/getPublisherId";
import { getMetaDataServiceUrl } from "js/crossword/sdk/getMetaDataServiceUrl";
import { Provider } from "js/crossword/types";
import PopupButtons from "./PopupButtons";

import styles from "../css/PuzzleRating.module.css";
import commonStyles from "../css/common.module.css";

export default Vue.extend({
  inject: [Provider.LOCALIZATION],
  props: ["puzzleId"],
  data() {
    return {
      step: 1,
      ratingStars: 0,
      improvementText: "",
      feedbackText: "",
      device: "",
      ratingFieldExpanded: false,
      ratingSent: false,
      email: "",
    };
  },
  methods: {
    changeRate(newValue: number) {
      this.ratingStars = newValue;
    },
    sendFeedback() {
      // if rated less then 5 stars and it's the first step, show "improvement" message
      if (this.ratingStars < 5 && this.step === 1) {
        this.step = 2;
        return;
      } 

      this.ratingSent = true;
      markPuzzleRating(this.puzzleId);

      const separator = this.feedbackText && this.improvementText ? " // " : ""

      const feedback = {
        puzzleId: this.puzzleId,
        stars: this.ratingStars,
        email: this.email,
        feedback: this.feedbackText + separator + this.improvementText,
        device: this.device,
        gameSlug: getGameSlug(),
        feedSlug: getFeedSlug(),
        publisherId: getPublisherId(),
      };
      const xhr = new XMLHttpRequest();
      xhr.open("POST", `${getMetaDataServiceUrl()}/notification`, true);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(JSON.stringify(feedback));
    },
    expandRatingField() {
      this.$emit("openRating");
      this.ratingFieldExpanded = true;
    },
    backButtonPressed() {
      if (this.step === 2) {
        this.step = 1;
        return;
      }

      this.$emit("closeRating");
      this.ratingFieldExpanded = false;
    },
  },
  render() {
    if (!this.ratingFieldExpanded) {
      return (
        <div class={styles.container}>
          <div class={styles.expandButton} onClick={this.expandRatingField}>
            <img class={styles.expandButtonIcon} src="images/Star_Full.svg" />
            <span>{this.localization.get("Rate our new crossword.")}</span>
          </div>
        </div>
      );
    }

    if (this.ratingSent) {
      return (
        <div class={styles.container}>
          <div>
            <div class={styles.thanks}>
              <img class={styles.thanksIcon} src="images/Feedback_Icon.svg" />
              <div>
                <div>{this.localization.get("Thanks for your feedback.")}</div>
                <div>{this.localization.get("We review all of them.")}</div>
              </div>
            </div>
            
            <PopupButtons buttons={[{
              label: this.localization.get("Resume"),
              onClick: () => this.$emit("closePopup"),
            }]} />
          </div>
        </div>
      );
    }

    return (
      <div class={styles.container}>
        <div>
          <div class={styles.question}>
            <img class={styles.questionIcon} src="images/Feedback_Icon.svg" />
            {this.step === 1
              ? <div class={commonStyles.lineBreakEnabled}>
                  {this.localization.get("How are you enjoying\nour new crossword?")}
                </div>
              : <div>
                  <div>{this.localization.get("Thanks for your feedback.")}</div>
                  <div>{this.localization.get("What can we improve to get 5 stars?")}</div>
                </div> }
          </div>

          {this.step === 1 
            ? <div class={styles.starsContainer}>
                {[1, 2, 3, 4, 5].map((id) => (
                  <img
                    key={id}
                    class={styles.star}
                    src={this.ratingStars >= id ? "images/Star_Full.svg" : "images/Star_Empty.svg"}
                    onClick={() => this.changeRate(id)}
                  />
                ))}
              </div>
            : null }
          
          <input
            type="email" v-model={this.email}
            class={styles.input}
            placeholder={this.localization.get("Email address")}>
          </input>
          <input
            type="deice" v-model={this.device}
            class={styles.input}
            placeholder={this.localization.get("Device")}>
          </input>
          {this.step === 1 
            ? <textarea
                v-model={this.feedbackText}
                class={[styles.input, styles.inputTextField]}
                placeholder={this.localization.get("Leave Feedback")}>
              </textarea>
            : <textarea
                v-model={this.improvementText}
                class={[styles.input, styles.inputTextField]}
                placeholder={this.localization.get("Leave Feedback")}>
              </textarea>
          }
          
          <br /><br />

          <PopupButtons buttons={[{
            label: this.localization.get("Back"),
            onClick: this.backButtonPressed,
            reversed: true,
          }, {
            label: this.localization.get("Send"),
            onClick: this.sendFeedback,
          }]} />
        </div>
      </div>
    );
  },
});
